<section>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-9">
        <div class="row">
          <h1>My Bookmarks</h1>
        </div>
        <hunt-package
          *ngFor="let uc of huntPackages"
          [data]="uc"
        ></hunt-package>
        <threat-profiles
          *ngFor="let tp of threatProfiles"
          [data]="tp"
        ></threat-profiles>
        <kendo-datapager
          [style.width.%]="100"
          [pageSize]="pageSize"
          [skip]="skip"
          [total]="totalItems"
          [pageSizeValues]="false"
          (pageChange)="onPageChange($event)"
        >
        </kendo-datapager>
      </div>
    </div>
  </div>
</section>
